import React from 'react';
import Loading from 'components/pure/utils/Loading';
import formatSecondsShort from 'utils/formatSecondsShort';
import {browserHistory} from 'react-router';
import {LinkIcon} from '@components/icon/LinkIcon';

export default class RepProfileCallDayDetails extends React.PureComponent {
  render() {
    return (
      <div className="day-details">
        {this.props.callDetailsLoading ? (
          <Loading />
        ) : this.props.callDetailsFailed ? (
          <p>Failed to load call details from server.</p>
        ) : !this.props.callDetails || this.props.callDetails.size === 0 ? (
          <p>No calls for this date.</p>
        ) : (
          <ol>
            {this.props.callDetails.map(call => (
              <li key={call.id}>
                <div className="time cell">{call.timestamp?.format('h:mm a')}</div>
                <div className="contact cell">{call.contact || '<Missing Contact>'}</div>
                <div className="title cell">{call.title || '<Missing Title>'}</div>
                <div className="company cell">{call.company || '<Missing Company>'}</div>
                <div className="duration cell">
                  {call.durationSeconds
                    ? formatSecondsShort(call.durationSeconds)
                    : '<Missing Duration>'}
                </div>
                <div className="result cell">{call.callStage || '<Missing Call Stage>'}</div>
                <div className="call-card-link cell">
                  <LinkIcon
                    onClick={() => browserHistory.push(`/call/${call.id}`)}
                    tooltip="Go to call"
                  />
                </div>
              </li>
            ))}
          </ol>
        )}
      </div>
    );
  }
}
